import gql from 'graphql-tag'

export const LIST_CONTENTS_QUERY = gql`
query ListContentsQuery {
  listContents {
    id,
    screenNo,
    nextScreenNo,
    prevScreenNo,
    parentAnxiety,
    parentCoping,
    parentReligiosity,
    parentFamilioso,
    parentSimpatia,
    surgeryType,
    pageName,
    content,
    noPadding
  }
}
`



// WEBPACK FOOTER //
// ./src/queries/LIST_CONTENTS_QUERY.ts